import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

import 'components/styles/date-picker.less';

export default class DatePicker extends React.Component {
  static propTypes = {
    value: PropTypes.object,
    onChange: PropTypes.func
  };

  state = {
    month: null,
    date: null,
    year: null
  };

  componentWillMount() {
    if (this.props.value) {
      this.setState({
        month: this.props.value.month(),
        date: this.props.value.date(),
        year: this.props.value.year()
      });
    }
  }

  getDates() {
    let dates = [];
    let i = 1;

    for (i = 1; i <= 31; i++) {
      dates.push(i);
    }

    return dates.map(v => (
      <option key={v} value={v}>
        {v}
      </option>
    ));
  }

  getYears() {
    let years = [];
    let i = 0;
    let start = new Date().getFullYear();

    for (i = 0; i <= 130; i++) {
      years.push(start - i);
    }

    return years.map(v => (
      <option key={v} value={v}>
        {v}
      </option>
    ));
  }

  emitChange() {
    let date = null;
    if (
      Number.isInteger(this.state.month) &&
      this.state.date &&
      this.state.year
    ) {
      date = moment(
        `${this.state.year}-${this.state.month + 1}-${this.state.date}`,
        'YYYY-MM-DD'
      );
    }

    this.props.onChange(date);
  }

  render() {
    return (
      <div className="date-picker">
        <select
          className="select-month"
          onChange={b => {
            this.state.month = parseInt(b.target.value, 10);
            this.emitChange();
          }}
          value={
            Number.isInteger(this.state.month) ? this.state.month : 'Month'
          }
        >
          <option default disabled>
            Month
          </option>
          <option value={0}>Jan</option>
          <option value={1}>Feb</option>
          <option value={2}>Mar</option>
          <option value={3}>Apr</option>
          <option value={4}>May</option>
          <option value={5}>Jun</option>
          <option value={6}>Jul</option>
          <option value={7}>Aug</option>
          <option value={8}>Sep</option>
          <option value={9}>Oct</option>
          <option value={10}>Nov</option>
          <option value={11}>Dec</option>
        </select>
        <select
          className="select-date"
          value={this.state.date ? this.state.date : 'Day'}
          onChange={b => {
            this.state.date = parseInt(b.target.value, 10);
            this.emitChange();
          }}
        >
          <option default disabled>
            Day
          </option>
          {this.getDates()}
        </select>
        <select
          className="select-year"
          value={this.state.year ? this.state.year : 'Year'}
          onChange={b => {
            this.state.year = parseInt(b.target.value, 10);
            this.emitChange();
          }}
        >
          <option default disabled>
            Year
          </option>
          {this.getYears()}
        </select>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./js/components/widgets/DatePicker.js